import { isDate } from 'date-fns'

export const isCorrectDate = (d?: string | null | Date): d is Date | string => {
  if (!d) return false
  const date = new Date(d)
  const isDateNaN = typeof d === 'string' && isNaN(Date.parse(d))
  if (!isDate(date) || isDateNaN) return false

  return true
}
